import "./LoginAuditView.scss";

import {AppContainer} from "../common/AppContainer";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {LoginAuditDto} from "../../domain/LoginAuditDto";
import {UsersActions} from "../../redux/UsersSlice";
import {LoginAuditService} from "../../services/login-audit/LoginAuditService";
import {AgGridReact} from "ag-grid-react";
import {DefaultGridOptions, DefaultMultiRowSelection, gridTheme, gridThemeDark} from "../../util/AgGridUtil";
import {ColDef, GridOptions, SelectionChangedEvent} from "ag-grid-community";
import {dateTimeFromTicks} from "../../util/DateHelper";
import {DateTime} from "luxon";
import {getCountryCodeEmojiAsUnicode} from "../../util/Formatters";

export const LoginAuditGrid = () => {
    const dispatch = useAppDispatch();

    const logins = useAppSelector(({usersState}) => usersState.logins);

    const isDark = useAppSelector(s => s.system.theme === "dark");

    function handleSelectionChanged(params: SelectionChangedEvent<LoginAuditDto>) {
        dispatch(UsersActions.selectLoginAudits(params.api.getSelectedRows()));
    }

    const gridOptions: GridOptions<LoginAuditDto> = {
        ...DefaultGridOptions,
        defaultColDef: {
            ...DefaultGridOptions.defaultColDef as any,
            resizable: true,
            sortable: true,
        },
        rowSelection: {
            mode: "multiRow",
            headerCheckbox: true,
            checkboxLocation: "selectionColumn",
            selectAll: "filtered",
            enableClickSelection: true,
            enableSelectionWithoutKeys: true,
        },
        tooltipShowDelay: 200,
    };

    const columnDefs: ColDef<LoginAuditDto>[] = [
        {
            field: "Location",
            headerName: "IP",
            width: 120,
        },
        {
            headerName: "Location",
            valueFormatter: ({data}) => (getCountryCodeEmojiAsUnicode(data?.LocationCode) ?? "") + " " + data?.LocationName,
            tooltipValueGetter: ({data}) => data?.LocationName ?? "",
        },
        {
            field: "LastLoginTime",
            headerName: "Last Login",
            width: 120,
            sort: "desc",
            valueFormatter: params => params.data ? dateTimeFromTicks(params.value).toLocaleString(DateTime.DATETIME_SHORT) : "",
        },
        {
            headerName: "User Agent",
            field: "UserAgent",
            flex: 1,
            minWidth: 600,
        },
    ];

    return (
        <div style={{flex: " 1 1 auto"}}>
            <AgGridReact<LoginAuditDto> theme={isDark ? gridThemeDark : gridTheme}
                                        gridOptions={gridOptions}
                                        rowSelection={DefaultMultiRowSelection}
                                        rowData={logins}
                                        columnDefs={columnDefs}
                                        getRowId={d => "" + d.data?.Id}
                                        onSelectionChanged={handleSelectionChanged}
            />
        </div>
    );
};

export const LoginAuditView = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        LoginAuditService.updateLoginAudits(dispatch).catch(console.error);
    }, [dispatch]);

    return (
        <AppContainer contentClassName="main-content login-audit-view">
            <LoginAuditGrid/>
        </AppContainer>
    );
}
